export enum TOAST_TYPE {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export type ToastProps = {
  id: string;
  title: string;
  description?: string;
  type?: TOAST_TYPE;
  duration?: number;
  autoClose?: boolean;
};

export type ToastOpts = Omit<ToastProps, 'id'>;

export type ToastContextType = {
  toasts: ToastProps[];
  addToast: (toast: ToastProps) => void;
  showSuccess: (toast: ToastProps) => void;
  showError: (toast: ToastProps) => void;
  showWarning: (toast: ToastProps) => void;
  removeToast: (id: string) => void;
};
